import React, { useEffect, useRef, useState } from "react";
import Buttons from "../../../../../../components/ui/button/Buttons";
import FormCreator from "../../../../../../components/finalForms/FormCreator";
import { addEfficiencyExtractConfig } from "./components/AddEfficiencyExtract.formfield.config";
import { useExportContractEfficiencyReportMutation, useLazyGetAllContractClientQuery } from "../../../../../../app/services/contractAPI";
import { setDropdownOptions } from "../../../../../../components/finalForms/libs/data/mapDropdownOptions";
import { saveAs } from 'file-saver';
import { setFieldSetting } from "../../../../../../utils/formFieldUtils/ManageFields";
import { FieldSettingType } from "../../../../../../components/finalForms/libs/data/fieldSettingType";
import SwalAlert from "../../../../../../services/swalService/SwalService";
import PropTypes from "prop-types";

const EfficiencyExtract = (props) => {
  const EfficiencyExtractref = useRef();
  const [efficiencyExtractForm, setEfficiencyExtractForm] = useState(addEfficiencyExtractConfig);
  const { error } = SwalAlert();


  const [getAllContractClient, {
    isFetching: isAllContractClientFetching,
    isSuccess: isAllContractClientFetched,
    data: allContractClientData,
  },] = useLazyGetAllContractClientQuery();

  const [getContractEfficiencyReport, {
    isLoading: isExporting,
    isSuccess: isAllExported,
    data: exportAllData
  },] = useExportContractEfficiencyReportMutation();

  useEffect(() => {
    getAllContractClient(0);
    setFieldSetting(efficiencyExtractForm, 'lClientKey', FieldSettingType.ISFIELDDATALOADING, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!isAllContractClientFetching && isAllContractClientFetched && allContractClientData) {
      const clientOptions = allContractClientData.map(item => {
        if (item.lClientKey === 0) {
          return {
            ...item,
            sClientName1: "All",
            lClientKey: "0"
          };
        }
        return item;
      });
      setDropdownOptions(clientOptions, 'lClientKey', 'sClientName1', efficiencyExtractForm, 'lClientKey', setEfficiencyExtractForm);
      setFieldSetting(efficiencyExtractForm, 'lClientKey', FieldSettingType.ISFIELDDATALOADING, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAllContractClientFetching, isAllContractClientFetched, allContractClientData]);

  useEffect(() => {
    if (!isExporting && isAllExported && exportAllData) {
      if (exportAllData.type === "application/json") {
        exportAllData.text().then(text => {
          const errorMesaage = JSON.parse(text);
          error("", errorMesaage.message);
        });
        return;
      }
      const blob = new Blob([exportAllData]);
      saveAs(blob, `Contracts Efficiency Report${props.currentDate}.xlsx`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isExporting, isAllExported, exportAllData]);

  const extractValue = (field) => {
    return field && typeof field === "object" ? field.value : field;
  };
  const handalExportEfficiency = () => {
    const formData = EfficiencyExtractref.current.getFormData();

    const req = {
      plContractKey: 0,
      psContractName: null,
      pbIncludeInactive: formData.isInactive,
      pbIncludeAll: false,
      pbAppendDatesToName: false,
      pbIncludeEfficiency: formData.isExpiring,
      psEfficiencyRating: formData.lEfficiency || "All",
      plClientKey: extractValue(formData.lClientKey) || "0"
    };

    getContractEfficiencyReport(req);
  }
  const handleFieldChange = (dataField, updatedFormData) => {

    const { isInactive } = updatedFormData;

    if (dataField === "isInactive") {
      let form = { ...addEfficiencyExtractConfig }
      form.initialState = {
        ...updatedFormData,
        isInactive: isInactive,
        lClientKey: null,
      }
      setEfficiencyExtractForm(form);
      return;
    }
  };



  const handleClear = () => {
    const form = { ...efficiencyExtractForm };
    form.initialState = { ...efficiencyExtractForm.initialState, isInactive: false, isExpiring: false };
    setEfficiencyExtractForm(form);
  }

  return (
    <div className="p-2">
      <FormCreator
        ref={EfficiencyExtractref}
        config={efficiencyExtractForm}
        onColumnChange={handleFieldChange}
      />
      <div className="bottom-text d-flex justify-content-start">
        <p className="mt-0" style={{ color: "black" }}>
          <b>
            <span>*</span>This extract can be time consuming, especially if
            including expired contract.
          </b>
        </p>
      </div>
      <div className="d-flex justify-content-center button-submit mb-2">
        <Buttons
          buttonText="Extract"
          buttonTypeClassName="btn blue-btn w-full"
          onClick={handalExportEfficiency}
        />
        <Buttons
          buttonText="Cancel"
          buttonTypeClassName="btn secondary-btn ml-4"
          onClick={handleClear}
        />
      </div>
    </div>
  );
};

EfficiencyExtract.propTypes = {
  currentDate: PropTypes.string.isRequired,
}

export default EfficiencyExtract;
